<template>
  <div>
    <div class="header">
      <!-- 顶部通知栏 (工业官网标准，极大提升B2B信任感) -->
      <div class="top-bar">
        <div class="top-bar__inner">
          <span class="top-bar__text">⭐ 广东中泉环保科技有限公司 · 环保设备设计、生产、维护一站式服务商</span>
          <div class="top-bar__phones">
            <span v-for="(c, idx) in company.contacts" :key="idx" class="top-bar__phone-item">
              📞 {{ c.name }}: <a :href="'tel:' + c.phone" class="top-bar__phone">{{ c.phone }}</a>
              <span v-if="idx < company.contacts.length - 1" class="separator">|</span>
            </span>
          </div>
        </div>
      </div>

      <b-navbar
        toggleable="lg"
        type="light"
        variant="light"
        :class="['site-nav', { 'site-nav--scrolled': scrolled }]"
      >
        <b-navbar-brand to="/" class="site-nav__brand">
          <img :src="logo" alt="中泉环保" class="site-nav__logo">
          <div class="brand-text">
            <span class="brand-text__main">{{ company.shortName }}</span>
            <span class="brand-text__sub">ENVIRONMENTAL TECH</span>
          </div>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse" right></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto align-items-lg-center">
            <b-nav-item href="#" :active="$route.path === '/'" @click="goHomeIntro">首页</b-nav-item>
            <b-nav-item to="/introduce">公司简介</b-nav-item>
            <b-nav-item to="/product">产品介绍</b-nav-item>
            <b-nav-item to="/knows">相关知识</b-nav-item>
            <b-nav-item to="/contact">联系我们</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>

<script>
import { COMPANY } from '@/constants/company'

export default {
  name: 'NavBar',
  data () {
    return {
      logo: '',
      company: COMPANY,
      scrolled: false
    }
  },
  created () {
    this.logo = require('../assets/logo.svg')
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll () {
      this.scrolled = window.scrollY > 10
    },
    goHomeIntro (event) {
      if (event) event.preventDefault()

      const scrollToIntro = () => {
        const intro = document.getElementById('company-intro')
        if (!intro) return
        const nav = document.querySelector('.header')
        const navHeight = nav ? nav.offsetHeight : 0
        const top = intro.getBoundingClientRect().top + window.pageYOffset - navHeight - 12
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' })
      }

      if (this.$route.path !== '/') {
        this.$router.push('/').catch(() => {})
        this.$nextTick(() => window.setTimeout(scrollToIntro, 120))
        return
      }

      scrollToIntro()
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}

.top-bar {
  background: var(--color-dark);
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.45rem 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);

  &__inner {
    max-width: var(--max-width);
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  &__phones {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  &__phone-item {
    display: flex;
    align-items: center;
    gap: 0.25rem;

    .separator {
      margin-left: 0.75rem;
      color: rgba(255, 255, 255, 0.25);
    }
  }

  &__phone {
    color: var(--color-accent);
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
      color: #fff;
    }
  }
}

.site-nav {
  background: rgba(255, 255, 255, 0.96) !important;
  backdrop-filter: blur(10px);
  box-shadow: none;
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  padding: 0.5rem 1.5rem;
  min-height: 4.5rem;
  border-bottom: 1px solid var(--color-border);

  &--scrolled {
    box-shadow: var(--shadow-sm);
    background: #ffffff !important;
    padding: 0.35rem 1.5rem;
  }

  &__brand {
    display: flex;
    align-items: center;
    font-weight: 700;
    color: var(--color-dark) !important;
    gap: 0.75rem;
  }

  &__logo {
    width: 6.5rem;
    height: auto;
    max-height: 2.25rem;
  }

  .brand-text {
    display: flex;
    flex-direction: column;
    text-align: left;
    line-height: 1.1;

    &__main {
      font-size: 1.15rem;
      font-weight: 800;
      letter-spacing: 0.05em;
      color: var(--color-dark);
    }
    &__sub {
      font-size: 0.6rem;
      font-weight: 700;
      color: var(--color-primary-dark);
      letter-spacing: 0.1em;
    }
  }
}

::v-deep .navbar-light .navbar-nav .nav-link {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--color-text-muted) !important;
  padding: 0.5rem 1.25rem !important;
  transition: all 0.25s;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 0.2rem;
    left: 50%;
    transform: translateX(-50%) scaleX(0);
    width: 1.25rem;
    height: 3px;
    border-radius: 2px;
    background: var(--color-primary);
    transition: transform 0.25s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  &:hover {
    color: var(--color-primary) !important;
    &::after {
      transform: translateX(-50%) scaleX(1);
    }
  }

  &.nuxt-link-exact-active,
  &.router-link-exact-active {
    color: var(--color-primary) !important;
    &::after {
      transform: translateX(-50%) scaleX(1);
    }
  }
}

@media (max-width: 992px) {
  .top-bar {
    display: none; // Hide top bar on smaller tablet/mobile
  }

  .site-nav {
    min-height: 4rem;
    padding: 0.5rem 1rem;

    &__cta {
      margin-left: 0;
      margin-top: 0.75rem;
      width: 100%;
    }
  }

  ::v-deep .navbar-light .navbar-nav .nav-link {
    padding: 0.75rem 1rem !important;
    border-bottom: 1px solid var(--color-border);

    &::after {
      display: none;
    }
  }
}
</style>
